import { Button } from 'antd'
import Style from './LoadMoreBtn.module.css'
import PropTypes from 'prop-types'
import { useState } from 'react'

const LoadMoreBtn = ({ disabledMore, disabledLess, onClickMore, onClickLess, hideDisabled = false }) => {

    const [loadingMore, setLoadingMore] = useState(false)
    const [loadingLess, setLoadingLess] = useState(false)
    return <>
        <div
            style={{
                textAlign: 'center',
                height: 32,
                lineHeight: '32px'
            }}
        >
            {!(disabledMore && hideDisabled) &&
                <Button className={`${Style["more-button"]}`}
                    disabled={disabledMore}
                    loading={loadingMore}
                    onClick={async () => {
                        setLoadingMore(true)
                        await onClickMore()
                        setLoadingMore(false)
                    }}>
                    MORE
                </Button>
            }
            {!(disabledLess && hideDisabled) &&
                <Button
                    className={`${Style["more-button"]} ${Style["margin-left-8"]}`}
                    disabled={disabledLess}
                    loading={loadingLess}
                    onClick={async () => {
                        setLoadingLess(true)
                        await onClickLess()
                        setLoadingLess(false)
                    }}
                >
                    LESS
                </Button>
            }
        </div>
    </>
}

LoadMoreBtn.propTypes = {
    disabledMore: PropTypes.bool,
    disabledLess: PropTypes.bool,
    onClickMore: PropTypes.func,
    onClickLess: PropTypes.func
}

export default LoadMoreBtn
